module.exports = __webpack_public_path__ + "static/img/wxgzh.3754b2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wxgzh.jpg
// module id = qo7d
// module chunks = 36